export function useFavicon() {
    const domain = useSettingsStore().get('cdn_domain');
    const version = 41;
    const colorMode = useColorMode()
    const updateFavicon = () => {
        const suffix = colorMode.value === 'light' ? '-light' : '-dark'
        const verQuery = `?v=${version}`
        const links = [
            { key: 'apple-touch-icon', rel: 'apple-touch-icon', sizes: '180x180', href: `${domain}/build/static/favicon/stonexbullion/apple-touch-icon${suffix}.png${verQuery}` },
            { key: 'icon32', rel: 'icon', type: 'image/png', sizes: '32x32', href: `${domain}/build/static/favicon/stonexbullion/favicon-32x32${suffix}.png${verQuery}` },
            { key: 'icon16', rel: 'icon', type: 'image/png', sizes: '16x16', href: `${domain}/build/static/favicon/stonexbullion/favicon-16x16${suffix}.png${verQuery}` },
            { key: 'manifest', rel: 'manifest', href: `${domain}/build/static/favicon/stonexbullion/site.webmanifest${verQuery}` },
            { key: 'mask-icon', rel: 'mask-icon', href: `${domain}/build/static/favicon/stonexbullion/safari-pinned-tab.svg${verQuery}`, color: '#030d17' },
            { key: 'shortcut-icon', rel: 'shortcut icon', href: `${domain}/build/static/favicon/stonexbullion/favicon${suffix}.ico${verQuery}` }
        ]
        useHead({ link: links })
    }

    updateFavicon()
    watch(colorMode, updateFavicon)

    return { updateFavicon }
}
